import FormRoomWrapper from './FormRoomInfo';

export default FormRoomWrapper;
